import { QuoteStatus } from '../enums/quoteStatus'

const DEFAULT_ALLOWED_TRANSITIONS = [QuoteStatus.Accepted, QuoteStatus.Rejected, QuoteStatus.Invoiced]

export const quoteStatusToAllowedTransitions: Record<QuoteStatus, QuoteStatus[]> = {
  [QuoteStatus.Created]: DEFAULT_ALLOWED_TRANSITIONS,
  [QuoteStatus.Sent]: DEFAULT_ALLOWED_TRANSITIONS,
  [QuoteStatus.Open]: DEFAULT_ALLOWED_TRANSITIONS,
  [QuoteStatus.Accepted]: [],
  [QuoteStatus.Rejected]: [QuoteStatus.Accepted],
  [QuoteStatus.Unsent]: DEFAULT_ALLOWED_TRANSITIONS,
  [QuoteStatus.Invoiced]: [], // keep empty — transitions will be added in STR-26
  [QuoteStatus.Deleted]: [], // keep empty to prevent transitions from deleted quote
}
